import {Snackbar as SnackbarDLS} from '@mediwareinc/wellsky-dls-react';
import ReactDOM from 'react-dom/client';
import {ThemeProvider} from '@/services/theme';
import styles from './snackbar.module.scss';

class Snackbar {
  visible = false;

  show(message) {
    if (document && !this.visible) {
      const root = ReactDOM.createRoot(document.createElement('div'));
      this.visible = true;

      root.render(
        <ThemeProvider>
          <SnackbarDLS
            className={styles.snackbar}
            show={true}
            message={message}
            onToggle={(visibility) => (this.visible = visibility)}
          />
        </ThemeProvider>,
      );
    }
  }
}

export const snackbar = new Snackbar();
